function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {

        let variant = event.detail.variant;
        let navScroller = document.getElementsByClassName('Product__SlideshowNavScroller')[0];


        navScroller.classList.add('is-hidden');
        flktyNav.deactivate();

        if (variant) {
            let sku = variant.sku.toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-image-variant="'+ sku +'"]').length;

            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if(thumb.classList.contains("has-video"))
                    {
                        thumb.classList.remove('hidden-tablet-and-up');
                    }
                    else
                    {
                        if (sku === thumb.dataset.imageVariant.toLowerCase()) {
                            thumb.classList.remove('hidden-tablet-and-up');
                        } else {
                            thumb.classList.add('hidden-tablet-and-up');
                        }    
                    }
                });
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
            }
        }

        flktyNav.activate();
        setTimeout(function () {
            navScroller.classList.remove('is-hidden');
        }, 750);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    toggleVariantThumbnails();
});

document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    var dealerButton = document.querySelector('.Button--dealer');
    var dealerButtonSpan = document.querySelector('.Button--dealer span');

    if (variant == null) {
      dealerButtonSpan.textContent = 'Unavailable';
      dealerButton.setAttribute('disabled', '');
    } else {
      dealerButtonSpan.textContent = 'Dealer Locator';
      dealerButton.removeAttribute('disabled', '');
    }
});
